<template>
  <div class="selectCompany">
    <v-select v-model="selectedCompany"
              :disabled="!editable || loading"
              :loading="loading"
              :items="companiesList"
              item-text="name"
              item-value="id"
              @change="selectCompany"
              dense light solo hide-details
              data-test="companySwitcher">
                <template v-slot:item="{ item }">
                  <span :data-test="`switchTo${item.name}Company`">
                    {{ item.name }}
                  </span>
                </template>
                <template v-slot:selection="{ item }">
                  <span :data-test="`activeCompanyIs${item.name}`">
                    {{ item.name }}
                  </span>
                </template>
              </v-select>
  </div>
</template>

<script>
import CurrentSession from '../mixins/CurrentSession'
import { Bus } from '../bus'

export default {
  name: 'ChangeCompany',
  mixins: [CurrentSession],
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedCompany: 0,
      loading: false
    }
  },
  created () {
    this.selectedCompany = this.$store.getters['auth/companyId']
  },
  computed: {
    companiesList () {
      return this.$store.getters['companies/companiesList']
    }
  },
  methods: {
    selectCompany () {
      if (this.selectedCompany === this.$store.getters['auth/companyId']) {
        return
      }
      this.loading = true
      this.$store.dispatch('auth/changeCompany', this.selectedCompany)
        .then(() => {
          Bus.$emit('alert', { color: 'success', message: `Current company is now ${this.currentCompany}` })
          this.loading = false
        })
        .catch((err) => {
          Bus.$emit('alert', { color: 'error', message: err })
          this.loading = false
        })
    }
  },
  watch: {
    currentCompany () {
      this.selectedCompany = this.$store.getters['auth/companyId']
    }
  }
}
</script>

<style lang="sass">
.selectCompany
  display: inline-block
  margin-top: 7px
  min-height: 44px
  max-width: 200px !important
  .v-input__control
    min-height: 38px !important
</style>
